import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import React from "react";
import bilal from "../assets/bilalhussain.jpg";
import christel from "../assets/christelcarbajal.jpg";
import matt from "../assets/mattpermentier.jpg";
import thomasb from "../assets/thomasbezemer.jpg";
import thomasm from "../assets/thomasmartini.jpg";

export default function TeamMembers() {
  return (
    <>
      <Typography variant="h4" mx={2} mb={2}>
        Teamleden
      </Typography>

      <Grid container spacing={2} px={2} mb={2}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Card>
            <CardMedia component="img" alt="Bilal Hussain" height="250" image={bilal} />
            <CardContent>
              <Typography variant="h6">Bilal Hussain</Typography>
              <Typography>1032518@hr.nl</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Card>
            <CardMedia component="img" alt="Christel Carbajal" height="250" image={christel} />
            <CardContent>
              <Typography variant="h6">Christel Carbajal</Typography>
              <Typography>1011926@hr.nl</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Card>
            <CardMedia component="img" alt="Matt Permentier" height="250" image={matt} />
            <CardContent>
              <Typography variant="h6">Matt Permentier</Typography>
              <Typography>1036181@hr.nl</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Card>
            <CardMedia component="img" alt="Thomas Bezemer" height="250" image={thomasb} />
            <CardContent>
              <Typography variant="h6">Thomas Bezemer</Typography>
              <Typography>0991914@hr.nl</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Card>
            <CardMedia component="img" alt="Thomas Martini" height="250" image={thomasm} />
            <CardContent>
              <Typography variant="h6">Thomas Martini</Typography>
              <Typography>1013596@hr.nl</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
